import React, { useContext } from 'react';
import { RESET_STATE, IS_LOGGED_IN, SET_USER, IS_LOADING, SET_SELECTED_PARENT_ID, SET_SESSION, SET_USER_ROLE, SET_SELECTED_LOCATION, SET_SELECTED_PROJECT, SET_PROJECTS, SET_LABELS } from './AppContext';
import { signin, sendEmail, resetPassword, changePassword, signout } from '../Server/auth';
import axios from '../../utils/axios';
import constants from '../../utils/constants';


const VerifyUserLogIn = (obj, appCtx, callback) => {
    appCtx.dispatch({ type: IS_LOADING, loading: true })
    signin(obj.email, obj.password)
        .then(response => {
            axios.defaults.headers.common['Authorization'] = `Bearer ${response.storage.accessToken}`
            localStorage.setItem('email', obj.email);
            localStorage.setItem('user_uuid', window.btoa(response.username));
            localStorage.setItem('accessToken', window.btoa(response.storage.accessToken));
            appCtx.dispatch({ type: IS_LOADING, loading: false });
            appCtx.dispatch({ type: IS_LOGGED_IN, login: true });
            appCtx.dispatch({ type: SET_SESSION, userSession: response })
            let returnParam = 1;
            if (
                response.challengeName === 'NEW_PASSWORD_REQUIRED' ||
                response.challengeName === 'FORCE_CHANGE_PASSWORD'
            )
                returnParam = 0;

            callback({ status: returnParam, user: response });
        })
        .catch(err => {
            appCtx.dispatch({ type: IS_LOADING, loading: false });
            appCtx.dispatch({ type: IS_LOGGED_IN, login: false })
            callback({ status: 2, user: err });
        });
}

const GetLabels = (locationId, appCtx, callback) => {
    if (locationId)
        axios.get(`${constants.URL_ORIGIN}/entity/label`, { params: { location_id: locationId } })
            .then((response) => {
                appCtx.dispatch({ type: SET_LABELS, labels: response.data });
                callback(true);
            })
            .catch(err => {
                appCtx.dispatch({ type: SET_LABELS, labels: err });
                callback(false);
            });
    else callback('location ID null')
}

const sendForgotEmail = (obj, appCtx, callback) => {
    appCtx.dispatch({ type: IS_LOADING, loading: true })
    const nonsensitiveemail = obj.email.toLowerCase();

    sendEmail(nonsensitiveemail)
        .then(response => {
            appCtx.dispatch({ type: IS_LOADING, loading: false });
            callback({ status: 1, user: response });
        })
        .catch(err => {
            appCtx.dispatch({ type: IS_LOADING, loading: false });
            appCtx.dispatch({ type: IS_LOGGED_IN, login: false })
            callback({ status: 2, user: err });
        });
}

const resetPasswordEmail = (obj, appCtx, callback) => {
    appCtx.dispatch({ type: IS_LOADING, loading: true })
    const nonsensitiveemail = obj.email.toLowerCase();

    resetPassword(nonsensitiveemail, obj.resetCode, obj.password)
        .then(response => {
            appCtx.dispatch({ type: IS_LOADING, loading: false });
            callback({ status: 1, user: response });
        })
        .catch(err => {
            appCtx.dispatch({ type: IS_LOADING, loading: false });
            appCtx.dispatch({ type: IS_LOGGED_IN, login: false })
            callback({ status: 2, user: err });
        });
}

const getIspProjects = (array) => {
    let filteredArray = [];
    array.children.map(childProj => {
        childProj.projects.map(project => {
            filteredArray.push(project)
        })
    })
    return filteredArray
}
const GetUserDetails = (appCtx, callback) => {
    appCtx.dispatch({ type: IS_LOADING, loading: true })
    axios.get(`${constants.URL_ORIGIN}/entity/user/${window.atob(localStorage.getItem('user_uuid'))}`, { params: { type: 'isp' } })
        .then((response) => {

            appCtx.dispatch({ type: IS_LOADING, loading: false })
            let projects = [];
            if (response.data.config && response.data.config.s3_details) {
                localStorage.setItem('media_base_url', response.data.config.s3_details.s3_base_url + response.data.config.s3_details.s3_bucket + '/')

            }
            if (response.data.user.role_name === 'isp') {

                projects = getIspProjects(response.data.locations[0]);
            }
            else {
                projects = response.data.locations[0].projects;
            }
            appCtx.dispatch({ type: SET_USER, userDetails: response.data });
            appCtx.dispatch({ type: SET_USER_ROLE, userRole: response.data.user.role_name });
            if (response.data.locations && response.data.locations.length > 0 && response.data.locations[0].parent_id) {
                localStorage.setItem('ParentID', response.data.locations[0].parent_id)
            }
            else {
                localStorage.setItem('ParentID', -1)
            }

            if (localStorage.getItem('LocationID')) {
                const prevID = localStorage.getItem('LocationID')
                const ProjExist = response.data.locations.filter(obj => {
                    if (obj.location_id === +prevID)
                        return obj.projects;
                })
                if (ProjExist.length > 0) {
                    appCtx.dispatch({ type: SET_SELECTED_LOCATION, selectedLocationId: prevID });
                    if (response.data.user.role_name === 'isp') {

                        projects = getIspProjects(ProjExist[0]);
                    }
                    else {

                        projects = ProjExist[0].projects;
                    }

                }
                else {
                    localStorage.setItem('LocationID', response.data.locations && response.data.locations.length > 0 ? response.data.locations[0].location_id : null)
                    appCtx.dispatch({ type: SET_SELECTED_LOCATION, selectedLocationId: response.data.locations && response.data.locations[0].location_id });
                }
            }
            else {
                localStorage.setItem('LocationID', response.data.locations && response.data.locations.length > 0 ? response.data.locations[0].location_id : null)

                appCtx.dispatch({ type: SET_SELECTED_LOCATION, selectedLocationId: response.data.locations && response.data.locations[0].location_id });
            }
            const filterProj = projects.filter(project => project.project_id !== -1)
            if (localStorage.getItem('ProjectID')) {
                if (filterProj.length === 1) {
                    appCtx.dispatch({ type: SET_SELECTED_PROJECT, selectedProjectId: filterProj[0].project_id });
                }
                else {
                    appCtx.dispatch({ type: SET_SELECTED_PROJECT, selectedProjectId: localStorage.getItem('ProjectID') });
                }
            }
            else {
                if (filterProj.length === 1) {
                    appCtx.dispatch({ type: SET_SELECTED_PROJECT, selectedProjectId: filterProj[0].project_id });
                }
                else {
                    localStorage.setItem('ProjectID', -1)
                    appCtx.dispatch({ type: SET_SELECTED_PROJECT, selectedProjectId: -1 });
                }
            }

            if (filterProj.length > 1) {

                projects.splice(0, 0, {
                    project_id: -1,
                    project_name: "All Projects",
                    project_code: null
                })
            }
            appCtx.dispatch({ type: SET_PROJECTS, projects: projects });
            appCtx.dispatch({ type: SET_USER, userDetails: response.data });
            appCtx.dispatch({ type: SET_USER_ROLE, userRole: response.data.user.role_name });
            appCtx.dispatch({ type: SET_SELECTED_PARENT_ID, selectedParentId: response.data.locations && response.data.locations[0].parent_id });
            GetLabels(response.data.locations && response.data.locations[0].location_id, appCtx, res => {
            })
            callback({ flag: true, data: response });//projects  SET_PROJECTS
        })
        .catch((err) => {
            appCtx.dispatch({ type: IS_LOADING, loading: false })
            callback({ flag: true, data: err });
        })
}

const SetSelectedLocation = (appCtx, locationID) => {
    localStorage.setItem('LocationID', locationID)

    appCtx.dispatch({ type: SET_SELECTED_LOCATION, selectedLocationId: locationID });

    const selectedLocation = appCtx.userDetails.locations.filter(obj => {
        if (obj.location_id === locationID)
            return obj;
    });
    if (selectedLocation.length > 0 && selectedLocation[0].parent_id) {
        appCtx.dispatch({ type: SET_SELECTED_PARENT_ID, selectedParentId: selectedLocation[0].parent_id });
        localStorage.setItem('ParentID', selectedLocation[0].parent_id);
    }
    else {
        localStorage.setItem('ParentID', -1)
    }


    let selectedProject = [];

    if (appCtx.userRole === 'isp') {

        selectedProject = getIspProjects(selectedLocation[0]);
    }
    else {
        selectedProject = selectedLocation[0].projects;
    }

    const filterProj = selectedProject.filter(project => project.project_id !== -1)
    if (filterProj.length > 1) {
        if (selectedProject.filter(project => project.project_id === -1).length === 0) {
            selectedProject.splice(0, 0, {
                project_id: -1,
                project_name: "All Projects",
                project_code: null
            })
        }
    }
    if (filterProj.length === 1) {
        localStorage.setItem('ProjectID', filterProj[0].project_id)

        appCtx.dispatch({ type: SET_SELECTED_PROJECT, selectedProjectId: filterProj[0].project_id });
    }
    else {
        localStorage.setItem('ProjectID', -1)
        appCtx.dispatch({ type: SET_SELECTED_PROJECT, selectedProjectId: -1 });
    }

    appCtx.dispatch({ type: SET_PROJECTS, projects: selectedProject });

    GetLabels(locationID, appCtx, res => {
    })
}

const SetProjectLocation = (appCtx, projectID) => {
    localStorage.setItem('ProjectID', projectID)
    appCtx.dispatch({ type: SET_SELECTED_PROJECT, selectedProjectId: projectID });
}


const SetUserLogin = (appCtx, state) => appCtx.dispatch({ type: IS_LOGGED_IN, login: state });

const S3UploadGetURL = (object, callback) => {
    return axios
        .get(`${constants.URL_ORIGIN}/s3/upload`, {
            params: object
        })
        .then(response => {
            callback({ flag: true, response: response });
        })
        .catch(err => {
            console.log(err);
        });
}

const S3UploadProfileImage = (url, data, callback) => {
    return fetch(url, {
        method: 'PUT',
        headers: {
            'Content-Type': 'image/png',
        },
        body: data
    }).then(response => {
        // if (response.status === 200) {
        callback({ flag: true, data: response });
        // }
    })
        .catch(err => {
            callback({ flag: false, data: err });
        });
}

const SendEmail = (data, callback) => {
    return axios.post(`${constants.URL_ORIGIN}/email/support`, {}, { data })
        .then((response) => {
            callback(true);
        })
        .catch((err) => {
            callback(false);
        });
}

const SetUserProfileDetails = (designation, phoneNumber, uuid, callback) => {
    //PUT /entity/user/

    let obj = {};
    if (phoneNumber)
        obj['phone_number'] = phoneNumber;
    if (designation)
        obj['designation'] = designation;
    return axios.put(`${constants.URL_ORIGIN}/entity/user/${uuid}`, obj)
        .then((response) => {
            callback(true);
        })
        .catch((err) => {
            callback(false);
        });
}

const changeUserProfilePassword = (OldPassword, NewPassword, callback) => {
    return changePassword(OldPassword, NewPassword)
        .then((response) => {
            callback(true);
        })
        .catch((err) => {
            callback(false);
        });
}

const SetUserLogOut = (appCtx, callback) => {
    signout()
        .then(response => {
            localStorage.removeItem('user_uuid');
            localStorage.removeItem('accessToken');
            appCtx.dispatch({ type: RESET_STATE });
            callback(true);
        })
        .catch(err => {
            callback(false);
        });
}

const resetAppContext = (appCtx) => {
    appCtx.dispatch({ type: RESET_STATE });
}


export default {
    SendEmail,
    SetSelectedLocation,
    VerifyUserLogIn,
    sendForgotEmail,
    GetUserDetails,
    SetUserLogin,
    SetProjectLocation,
    resetPasswordEmail,
    S3UploadGetURL,
    S3UploadProfileImage,
    SetUserProfileDetails,
    changeUserProfilePassword,
    SetUserLogOut,
    resetAppContext
}